<template>
  <v-container class="AutoLogin">
    <LoadingScreen :statusLoading="true"></LoadingScreen>
  </v-container>
</template>

<script>
import LoadingScreen from "@/components/widget/LoadingScreen.vue";
import axios_auth from "@/plugins/axios_auth";
import base64 from "base-64";

export default {
  name: "AutoLogin",
  components: {LoadingScreen},
  data() {
    return {
      username: null,
      keycode: null,
      UrlCode: null,
      system_key: '27B2145262B24348B3FFEE477B51CE62',
    }
  },
  mounted: function () {

    if((this.$route.query.UrlCode) && (this.$route.query.hasOwnProperty('UrlCode'))){
      this.UrlCode = this.$route.query.UrlCode;
    }

    //https://mobileapps.lpn.co.th/rms-booking/loginAuto1895?username=<userId>&kc=301C64B1CF8E4E239E67B95E8E40B092
    if( (this.$route.query.username) && (this.$route.query.hasOwnProperty('username') )
        &&  (this.$route.query.kc) && (this.$route.query.hasOwnProperty('kc') )
    ){

      this.keycode = this.$route.query.kc;
      this.username = base64.decode(this.$route.query.username);//this.$route.query.username;

      if(this.keycode === '301C64B1CF8E4E239E67B95E8E40B092'){
        this.AutoLoginUser();
      }else{
        return this.goToUrl('/');
      }


    }else{
      return this.goToUrl('/');
    }

  },
  methods: {

    AutoLoginUser: async function() {

      try {
        let DataUser = {
          username: this.username,
          system_key: this.system_key
        };

        await axios_auth.post('/AuthSystem98218/AuthenticationByKey', JSON.stringify(DataUser))
            .then(res => {

              if (res.data.status === "1") {
                //set user token to localStorage
                let auth_data = {
                  'refreshToken': res.data.refreshToken,
                  'token': res.data.jwt,
                  'user_id': this.username
                }
                localStorage.setItem('RmsBookingAuth', JSON.stringify(auth_data))

              }

            }).then(() => {

          this.refreshToken().then((res) => {
            let auth_data = {
              'refreshToken': res.refreshToken,
              'token': res.jwt,
              'user_id': this.username,
              'availableUntil': res.availableUntil
            }

            localStorage.setItem('RmsBookingAuth', JSON.stringify(auth_data));
            this.CheckAccessSystem();

          });
        }).catch(err => {

          if (err.response) {

            if (err.response.status === 401) {
             alert("ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง");
             return false;
            } else {
              alert(err.response.data.msg);
              return  false;
            }

          }
        });



      } catch (err2) {
        alert(err2.message);
        return false;
      }
    },
    CheckAccessSystem: async function(){

      this.setAuthHeader();

      let Result = await this.PostHttp('RmsSite/CheckLogin', {username: this.username});
      Result = Result.res.data;
      if (Result.statusAccess) {
        this.$emit('showLogoutMenu', {status: true});
        localStorage.setItem('RmsBookingUserAccess', JSON.stringify(Result));

        if(this.UrlCode === '3001'){

          let ObjGet = this.$route.query;

          let url = '/FrmQuotation?actionid=1';

          if(ObjGet.pjcode) {
            url += '&pjcode=' + ObjGet.pjcode;
          }

          if(ObjGet.campaigncode) {
            url += '&campaigncode=' + ObjGet.campaigncode;
          }

          if(ObjGet.pdcode) {
            url += '&pdcode=' + ObjGet.pdcode;
          }

          if(ObjGet.fname) {
            url += '&fname=' + ObjGet.fname;
          }

          if(ObjGet.fname) {
            url += '&lname='+ ObjGet.lname;
          }

          if(ObjGet.phoneno) {
            url += '&phoneno='+ ObjGet.phoneno;
          }

          if(ObjGet.regrunno) {
            url += '&regrunno='+ ObjGet.regrunno;
          }

          if(ObjGet.prcode) {
            url += '&prcode='+ ObjGet.prcode;
          }

          if(ObjGet.leid) {
            url += '&leid='+ ObjGet.leid;
          }


          return this.goToUrl2(url);


        }else if(this.UrlCode === '3002'){
          return this.goToUrl2('/ListQuotation');
        }else {
          return this.goToUrl('/HomeBooking');
        }

      } else {

        alert('You Can not access system');
        localStorage.removeItem('RmsBookingAuth');
        localStorage.removeItem('RmsBookingUserAccess');
        return false;
      }


    },


  }
}
</script>

<style scoped>

</style>